import { NotificationStore } from '../../../../store/NotificationStore';
import { withLearnerImportNotifications } from '../../../../decorators/notification/withLearnerImportNotifications';

@withLearnerImportNotifications
export class EvidenceMeNotificationStore extends NotificationStore {
  
  static instance = null;
  
  static getInstance() {
    if (!EvidenceMeNotificationStore.instance) {
      EvidenceMeNotificationStore.instance = new EvidenceMeNotificationStore();
    }
    return EvidenceMeNotificationStore.instance;
  }
  
  static destroy() {
    EvidenceMeNotificationStore.getInstance().destroy();
    EvidenceMeNotificationStore.instance = null;
  }
  
  
}
